import { useCallback, useEffect, useRef, useState } from "react";
import type { LabReportFile } from "@ferrivia/api-contract";
import { useApi } from "@ferrivia/auth-web";

export interface UseLabReportFilesResult {
  files: LabReportFile[];
  refetch: () => void;
}

export function useLabReportFiles(enabled: boolean): UseLabReportFilesResult {
  const api = useApi();
  const [files, setFiles] = useState<LabReportFile[]>([]);
  const cancelledRef = useRef(false);

  const fetchFiles = useCallback(() => {
    if (!enabled) return;
    api.labs
      .listReportFiles()
      .then((list) => {
        if (!cancelledRef.current) setFiles(list);
      })
      .catch(() => {});
  }, [api, enabled]);

  useEffect(() => {
    cancelledRef.current = false;
    fetchFiles();
    return () => {
      cancelledRef.current = true;
    };
  }, [fetchFiles]);

  return { files, refetch: fetchFiles };
}
